var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-upload',{ref:"upload",attrs:{"value":_vm.files},on:{"input-filter":_vm.inputFilter,"input":_vm.updatedValue}},[_c('v-avatar',{staticClass:"pointer",attrs:{"color":"rgb(0, 0, 0, 0.1)","size":"40"}},[_c('v-icon',[_vm._v(" attach_file")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }